/*
 * Modify default api response value representation
 * according to mockups
 */
/* eslint-disable */

import React from 'react';
import { FormattedMessage } from 'react-intl';
import get from 'lodash/get';
import Question from '../../SequentialSurvey/Question';
import InfoBtn from '../../common/InfoBtn';
import Range from '../../common/Range';
import Info from '../../common/InfoBtn/Info';
import { ACTIONS, COMMON } from '../../../constants/strings';
import { QUESTION_TYPES } from '../../../constants/props';
import { isDesktop } from '../../../utils/mobileHelpers';

export const QUESTION = 'question';

const getQuestion = (question, assignmentId) => {
  const markOptional = () => <FormattedMessage {...ACTIONS.survey.optional} />;
  const questionPlaceholder = (
    <Question
      {...question}
      assignmentId={assignmentId}
      markOptional={markOptional}
    />
  );

  return { value: questionPlaceholder, triggered: false };
};

const getGeneral = ({ value, triggered }) => {
  if (value && value === '—') return value;
  const textRef = value === 'true' ? 'yes' : 'no';
  const text = <FormattedMessage {...COMMON[textRef]} />;
  const newValue = <span className="ttu">{text}</span>;

  return { value: newValue, triggered };
};

const getText = ({ value, triggered }, expanded) => {
  if (value && value === '—') return value;
  const newValue = expanded ? (
    <p className="dib tl word-wrap">{value}</p>
  ) : (
    <InfoBtn value={value} />
  );

  return { value: newValue, triggered };
};

const getSelect = ({ value, triggered }, expanded) => {
  if (value && value === '—') return value;
  const newValue = expanded ? (
    <Info value={value} />
  ) : (
    <InfoBtn iconName="list" value={value} />
  );

  return { value: newValue, triggered };
};

const getScale = ({ value, description, triggered }, expanded) => {
  const newValue =
    expanded && isDesktop() ? (
      <Range scale={description} selected={value} />
    ) : expanded ? (
      `${value} out of ${description.maxValue}`
    ) : (
      value
    );

  return { value: newValue, triggered };
};

export default (answer, expanded, assignmentId) => {
  const type = get(answer, 'type');

  switch (type) {
    case QUESTION:
      return getQuestion(answer, assignmentId);
    case QUESTION_TYPES.general:
      return getGeneral(answer);
    case QUESTION_TYPES.text:
      return getText(answer, expanded);
    case QUESTION_TYPES.multiSelect:
    case QUESTION_TYPES.singleSelect:
      return getSelect(answer, expanded);
    case QUESTION_TYPES.scale:
      return getScale(answer, expanded);
    default:
      return answer;
  }
};



// WEBPACK FOOTER //
// ./src/components/Survey/helpers/handleValue.js